import React from 'react'

// STYLES
import styled from 'styled-components'

const Line = ({className}) => <div className={className} />

const LineWithStyles = styled(Line)`
    max-width: 1080px;
    height: 1px;
    background-color: #D4D4D4;
    margin-bottom: 20px;
    margin-left: auto; 
    margin-right: auto;
`

export default LineWithStyles



// WEBPACK FOOTER //
// ./src/components/line/line.component.js